import Skeleton from "ui-components/Skeleton";

import { useFetchDataFile, useFetchDataFiles } from "modules/data-files/api";

import { useGetFileColumnRenamers } from "./store";

import KeepDrop from "./Keep-Drop";
import ColumnName from "./Col-Name";
import ColumnTag from "./Column-Tag";
import ChangeTypes from "./Change-Types";

const EmptyDiv = ({ fileId }: { fileId: string }) => {
  useFetchDataFile(fileId, true);
  return <div className="hidden"></div>;
};

const Controls = ({ selectedFiles }: { selectedFiles: string[] }) => {
  const selectedData = useFetchDataFiles(selectedFiles);

  const fileDetails = Object.fromEntries(
    selectedFiles.map((f, i) => [f, selectedData[i].data])
  );

  const renamers = useGetFileColumnRenamers(selectedFiles);

  const renamedColumns = Array.from(
    new Set(
      selectedFiles
        .map((f) =>
          (fileDetails[f]?.columns || []).map((c) => renamers[f][c] || c)
        )
        .flat()
    )
  ).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));

  if (selectedData.filter((d) => d.data).length === 0) {
    return <Skeleton />;
  }

  return (
    <>
      <table className="table w-full table-fixed">
        <thead>
          <tr>
            <th className="text-left">
              <p className="p-1">Column</p>
            </th>
            <th>
              <p className="p-1">Type</p>
            </th>
            <th>
              <p className="p-1">Actions</p>
            </th>
          </tr>
        </thead>
        <tbody>
          {renamedColumns.map((c) => (
            <tr key={c} className="border-t">
              <td>
                <ColumnName fileIds={selectedFiles} column={c} />
              </td>
              <td>
                <div className="flex flex-wrap p-1">
                  {selectedFiles
                    .filter((f) => fileDetails[f])
                    .map((f) => (
                      <ColumnTag
                        key={f}
                        fileId={f}
                        fileDetails={fileDetails[f]}
                        column={c}
                      />
                    ))}
                </div>
              </td>
              <td>
                <div className="p-1">
                  <KeepDrop fileIds={selectedFiles} column={c} />
                  <ChangeTypes
                    fileIds={selectedFiles}
                    column={c}
                    fileDetails={fileDetails}
                  />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {selectedFiles.map((f) => (
        <EmptyDiv key={f} fileId={f} />
      ))}
    </>
  );
};

export default Controls;
